//replaces singlemetric.html
import { SingleMetricCpcTemplateV2 } from "app/components/widget/dashboard/singleMetric/SingleMetricCpcTemplate-v2";
import { SingleMetricSearchesTemplateV2 } from "app/components/widget/dashboard/singleMetric/SingleMetricSearchesTemplate-v2";
//replaces sw-single-metric.js
import { SingleMetricTemplateV2 } from "app/components/widget/dashboard/singleMetric/SingleMetricTemplate-v2";
import { SingleMetricWebsiteOverviewChangePopTemplateV2 } from "app/components/widget/dashboard/singleMetric/SingleMetricWebsiteOverviewChangePopTemplate-v2";
import type { FC } from "react";
import { useMemo } from "react";
import type { IDashboardWidgetInterface } from "../../utils/DashboardWidgetsInterfaces-v2";
import { SingleMetricTotalVisitsWithShareTemplateV2 } from "app/components/widget/dashboard/singleMetric/SingleMetricTotalVisitsWithShareTemplateV2";

// for use with the trend-line cell template
export const SingleMetricContainerTemplateV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget } = props;
    const Component = useMemo<any>(() => {
        const template = widget.viewOptions.template;
        if (template) {
            const templateName = template.substring(template.lastIndexOf("/") + 1);
            switch (templateName) {
                case "single-metric-website-overview-change-pop.html":
                    return SingleMetricWebsiteOverviewChangePopTemplateV2;
                case "cpc-dashboard.html":
                    return SingleMetricCpcTemplateV2;
                case "searches-dashboard.html":
                    return SingleMetricSearchesTemplateV2;
                case "total-visits-with-share.html":
                    return SingleMetricTotalVisitsWithShareTemplateV2;
            }
            console.error("Could not find singleMetricWidget for ", widget.viewOptions.template);
            return null;
        }

        return SingleMetricTemplateV2;
    }, []);

    return (
        <>
            {widget.data ? (
                <Component
                    data={widget.data}
                    rows={widget.metadata.rows}
                    options={widget.viewOptions}
                    widget={widget}
                />
            ) : null}
        </>
    );
};
